// Public booking page links, shared by the URL and iframe code in Settings.

export const DEFAULT_PRIMARY_COLOR = "E7424C";
export const DEFAULT_SECONDARY_COLOR = "ffffff";

// colors go in the URL path without "#": a "#" would end the path and break the link
const cleanColor = (color, fallback) => {
  const value = String(color ?? "").trim().replace(/^#/, "");
  return /^[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/.test(value) ? value : fallback;
};

export const buildBookingUrl = (customerId, primaryColor, secondaryColor) =>
  `${window.location.origin}/public/user-reservation/${encodeURIComponent(customerId)}/` +
  `${cleanColor(primaryColor, DEFAULT_PRIMARY_COLOR)}/${cleanColor(secondaryColor, DEFAULT_SECONDARY_COLOR)}`;

export const buildIframeCode = (url) =>
  `<iframe src="${url}" width="500" height="600" style="border:0;max-width:100%;"></iframe>`;

// "#rrggbb" for <input type="color">
export const toColorInput = (color, fallback) => `#${cleanColor(color, fallback)}`;
